
export { LucideIcon } from "/codebuild/output/src3584820406/src/packages/shared-components/src/components/LucideIcon.tsx"